import { Grid } from '@mui/material';

import { graphql, type DocumentType } from '@/gql';

import { extractConnectionProps } from '@/utils/queries/queryExtracts';

import { AssistantConversationItem } from './conversation/AssistantConversationItem';

export const MESSAGE_LIMIT = 10;
export const MESSAGE_LIMIT_WARNING_THRESHOLD = 8;

export const ORTOO_GPT_CONVERSATION_ITEM_FRAGMENT = graphql(`
  fragment ortooGptConversationItemFields on OrtooGptConversationItem {
    _id
    experimental
    response {
      responseText
      knowledgeSourcesConnection {
        edges {
          node {
            title
            url
            cosineSimilarity
            wagtailRef
          }
        }
      }
      intercomSourcesConnection {
        edges {
          node {
            title
            url
            cosineSimilarity
          }
        }
      }
    }
    prompt {
      text
      fileIdsConnection {
        edges {
          node {
            _id
            _exists
            filename
          }
        }
      }
    }
    feedbacksConnection {
      edges {
        node {
          user {
            _id
          }
          rating
          comment
        }
      }
    }
  }
`);

export const ASSISTANT_CONVERSATION_ITEMS_CONNECTION_FRAGMENT = graphql(`
  fragment assistantConversationItemsConnectionFragment on OrtooGptConversationItemsConnection {
    edges {
      node {
        ...assistantConversationItemItemFields
      }
    }
  }
`);

export const ASSISTANT_CONVERSATION_CONVERSATION_WITHOUT_ITEMS_FRAGMENT =
  graphql(`
    fragment assistantConversationConversationWithoutItemsFragment on OrtooGptConversation {
      ...assistantConversationItemConversationFields
      _id
      caption
    }
  `);

const ASSISTANT_CONVERSATION_CONVERSATION_FRAGMENT = graphql(`
  fragment assistantConversationConversationFragment on OrtooGptConversation {
    ...assistantConversationConversationWithoutItemsFragment
    itemsConnection {
      ...assistantConversationItemsConnectionFragment
    }
  }
`);

interface Props {
  conversation: DocumentType<
    typeof ASSISTANT_CONVERSATION_CONVERSATION_FRAGMENT
  >;
}

export const AssistantConversation = ({ conversation }: Props) => {
  const { itemsConnection } = conversation;
  const items = extractConnectionProps(itemsConnection);

  return (
    <Grid container spacing={2}>
      {items.map((item, index) => {
        return (
          <AssistantConversationItem
            key={index}
            conversation={conversation}
            item={item}
          />
        );
      })}
    </Grid>
  );
};
